import React from 'react';
import { FormikProps } from 'formik';
import { RelationshipsProps } from '../../models/account-info-epi-props';
import { LabelSettingProps } from '../../../../global/models/epi-model';
import { PersonFieldsDisplay } from '../../components/read-only/person-fields-display';
import { MailingAddressDisplay } from '../../components/read-only/mailing-address-display';
import { PhonesDisplay } from '../../components/read-only/phones-display';
import { EmailsDisplay } from '../../components/read-only/emails-display';
import { DependentFormValues } from './dependent-form-models';
import { LabelAndValue } from '../../../../global/components/data-display/label-value';
import { ChildTypes, DependentTypes } from './dependents-model';

interface Props {
    labelSetting: LabelSettingProps;
    relationshipsProps: RelationshipsProps;
    formProps: FormikProps<DependentFormValues>;
    selectedPerson: boolean;
}
export function DependentConfirmation(props: Props) {

    const { labelSetting, formProps, relationshipsProps, selectedPerson } = props;
    const { values } = formProps;

    return (
        <>
            <LabelAndValue label={relationshipsProps.relationshipLabel} value={values.dependent_type} />
            {
                values.dependent_type === DependentTypes.child &&
                <LabelAndValue label={relationshipsProps.stepchidlQuestionLabel} value={values.child_type === ChildTypes.step ? labelSetting.yesText : labelSetting.noText} />
            }
            {
                values.dependent_type === DependentTypes.child && !selectedPerson &&
                <LabelAndValue label={relationshipsProps.disabledChildQuestionLabel} value={values.disabled_child_indicator === 'Y' ? labelSetting.yesText : labelSetting.noText} />
            }

            <PersonFieldsDisplay
                labelSetting={labelSetting}
                values={values}
                sectionText={relationshipsProps.dependentInformationSectionLabel}
                dobMasked={selectedPerson}
            />
            <MailingAddressDisplay
                labelSetting={labelSetting}
                values={values}
            />

            <PhonesDisplay
                labelSetting={labelSetting}
                values={values}
            />

            <EmailsDisplay
                labelSetting={labelSetting}
                values={values}
            />

        </>
    );
}